import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoCadastroCfopDto,
  TributacaoCadastroDto,
  TributacaoCadastroSchema,
} from "./TributacaoCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import { useToast } from "src/componentes/Toast/Toast";
import {
  TributacaoAtualizar,
  TributacaoBuscarPorId,
  TributacaoIncluir,
} from "src/services/Fiscal.Service";

const TributacaoCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const { showToast } = useToast();
  const [data, setData] = useState<TributacaoCadastroCfopDto[] | undefined>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<TributacaoCadastroDto>({
    resolver: yupResolver(TributacaoCadastroSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoBuscarPorId(id);
          if (response.data.success) {
            const data = response.data.data;
            reset(data);
            setIncluir(false);
            setData(data.cfop);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar Tributacao",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.tipoOperacao = Number(data.tipoOperacao);
    if (incluir) {
      TributacaoIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/fiscal/tributacao");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      TributacaoAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/fiscal/tributacao");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
    incluir,
    data,
  };
};
export default TributacaoCadastroCode;
